import { render, staticRenderFns } from "./FormularioSaludInfatil.vue?vue&type=template&id=3cf7cce0&scoped=true"
import script from "./FormularioSaludInfatil.vue?vue&type=script&lang=js"
export * from "./FormularioSaludInfatil.vue?vue&type=script&lang=js"
import style0 from "./FormularioSaludInfatil.vue?vue&type=style&index=0&id=3cf7cce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf7cce0",
  null
  
)

export default component.exports